import React ,{ useState }from "react";

import { Bounce } from 'react-activity';
import 'react-activity/dist/react-activity.css';

import Drawer from '@material-ui/core/Drawer';

import {getMyProfile,getLocations,getInventoryReport, getMyAccounts,getMaster,getAccounts ,InventorySummaryExport} from "../../crud/auth.crud";
import { Link } from "react-router-dom";
import { IconButton,TextField,MenuItem,InputLabel,Select } from '@material-ui/core';
import { Tooltip } from "@material-ui/core";	
//import InfiniteScroll from "react-infinite-scroller";
import SearchIcon from '@material-ui/icons/Search';
import DateFnsUtils from '@date-io/date-fns';
import {  format } from 'date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import Grid from '@material-ui/core/Grid';					
import EditIcon from '@material-ui/icons/Edit';		
import Checkbox from '@material-ui/core/Checkbox';
//import PaymentIcon from '@material-ui/icons/Payment';
import DescriptionIcon from '@material-ui/icons/Description';
import ReceiptIcon from '@material-ui/icons/Receipt';

import Button from '@material-ui/core/Button';
//import SaveIcon from '@material-ui/icons/Save';
import Icon from '@material-ui/core/Icon';
 import CodeExample from "../../partials/content/CodeExample";
//import setDisplay from "../../partials/content/CodeExample";
import EditOrderReqStatus from './EditOrderReqStatus'
import FormGroup from '@material-ui/core/FormGroup';



 
import Autocomplete from '@material-ui/lab/Autocomplete';
//import { ThreeDRotationSharp, TrendingUpOutlined } from "@material-ui/icons";
 import BootstrapTable from 'react-bootstrap-table-next';
 import filterFactory, { textFilter,numberFilter } from 'react-bootstrap-table2-filter';
 import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
 import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
 import paginationFactory from 'react-bootstrap-table2-paginator'

 import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

 import Alert from '@material-ui/lab/Alert'
 
 
 import CircularProgress from '@material-ui/core/CircularProgress';
import { Portlet, PortletBody, PortletHeader } from "../../partials/content/Portlet";







//import Moment from 'moment';
 

export default class InventoryReport extends React.Component {

	defaultSorted = [{
		dataField: 'totalQuantity',
		order: 'desc'
	  }];
	
	  columns = [
	 	{
		  dataField: '_id',
		  text: 'Product',
		  width: 150,
		  sort: false,
		  
		},
		{
		  dataField: 'totalQuantity',
		  text: 'Scanned Stock',
		  sort:false,
		  
		  headerStyle: {
    		width: '100px'
  			}
		 
		}	,
		{
		  dataField: 'totalAvailable',
		  text: 'Current Stock',
		  sort:false,
		  
		  headerStyle: {
    		width: '100px'
  			}
		 
		}	
		,
		{
		  dataField: 'totalUtilized',
		  text: 'Utilized Stock',
		  sort:false,
		  
		  headerStyle: {
    		width: '100px'
  			}
		 
		}	
	  ];

priceFormatter(cell, row) {
  if (row.total) {
    return (
      <span>
        <strong style={ { color: 'green' } }>$ { cell.toFixed(2) }</strong>
      </span>
    );
  }

  return (
    <span>$ { cell.toFixed(2) }</span>
  );
}
 
  handleDateChange = (date) => {
    this.setState({selectedDate : date});
  };

  state = {
    schedules:[],
    pRights:[],
    hasMoreItems:false,
    page:1,
        isReset:false,

    isLoading:false,
        filterFields :{},
    fields:[],
    filter:false,
    selectedDate:null,
    open:false,
    notes:[],
    notesId:'',
    statusSettings:
        "JOBS00003"
    ,
    postObj:{},
	statusFilter:null,
	selectedDrawerItem:null,
	invoiceDrawerOpen:false,
	invoiceViewDrawerOpen:false,
	jobServiceTypes:[],
	permission:[],
	columns :this.columns,
    defaultSorted: this.defaultSorted,
	tableData:[],
	entity:[],
    accounts:[],
    businessEntity:'',
    selaccount:null,
	lookUp: {product:'productKey',account:'accountKey'},
	groupBy: [],
	reportBy:[],
	dateCreatedTo:null,
	dateCreatedFrom:null,
	locations:[],

  }

 constructor(props)
{
	super(props);


}




resetFilter()
{
	let postObj={};
  		//this.state.filter=false;
  		  		this.setState({isReset:false});
  		  		
  		  		this.setState({filter:false},function(){
					this.setState({filter:true})		
  		  		})
				
  		  		
  	 	this.state.fields[0].fields.map((field)=> {
  			
  			this.state[`Filter_${field.fieldName}`]=null;

 
  			})
}

	reserFilterText()
	{
		this.setState({filter:true})
	}

   handleReset(event)
  {
  		let postObj={};
  		//this.state.filter=false;
  		  		this.setState({isReset:true});
  		  		
  		  		this.setState({filter:false},function(){
					this.setState({filter:true})		
  		  		})
				
  		  		
  	 	this.state.fields[0].fields.map((field)=> {
  			
  			this.state[`Filter_${field.fieldName}`]=null;
			if(field.dataType==='autocomplete')
			{
				this.setState({[field.fieldName]:[],[`Filter_${field.fieldName}`]:''});
				
			}
 
  			})

  			this.setState({activePage:1})
			  
  }

  
 async componentDidMount()
  {
 
  
	this.setState({isLoading:true});

	 await getMyProfile().then(response => response.data)
		.then((data) => {
		  this.setState({ currentUser: data })
		  console.log("currentUser::::",data);

			getLocations(1,100,'locationName','asc',{accountKey:data[0].accountKey})
				.then((response) => {
					this.setState({ locations:response.data})					
					console.log("locations:::::",response.data);
				});
		});
		
	
					
   

  	this.setState({hasMoreItems:false,isLoading:true});
  	

    let postObj={};
			
  	

   getInventoryReport("",'available',postObj)//.then(response => response.data)
    .then((response) => {
      this.setState({isLoading:false});
      this.setState({ tableData: response.data});
     
     })


  }
 



  handleChangeLocation=(event)=>
  {
    console.log(event);
    this.setState({locationKey:event.target.value});
	
    
  }
 

    handleFilter(event)
	{
   
	   this.setState({isLoading:true})
	   let params = {};
	   if(this.state.locationKey!==null && this.state.locationKey!=="")
	   {
			console.log(this.state.selaccount);
			params.locationKey = this.state.locationKey;
		 
	   }
	  
	   let group = this.state.groupBy.toString();
			if(this.state.groupBy.toString()==="") group="productKey"; 

		  getInventoryReport(group,this.state.reportBy.toString(),params)//.then(response => response.data)
    	  .then((response) => {
      	 		this.setState({isLoading:false})
      	  		this.setState({ tableData: response.data,columns:this.state.columns,postObj:params})
     
     		})
   
	 }

	autocompleteOnChange=(event,newValue,fieldName,lookupKey) => {
		if(event!==null && newValue!==null)
		{
		  console.log("autocomplete change:::",event ,newValue,fieldName,lookupKey,newValue[lookupKey]);
		  this.setState({[fieldName]:newValue[lookupKey]});
		}
		
	  }
	    exportClick(event)
		{
			
		
				let postObj={};
			//console.log(this.state.fields.fields);
	  
		 if(this.state.locationKey!==null && this.state.locationKey!=="")
	   {
			console.log(this.state.selaccount);
			postObj.locationKey = this.state.locationKey;
		 
	   }
					InventorySummaryExport("productKey",this.state.reportBy.toString(),postObj)
							.then((response) => {
							  if(response.data!=""){
								var win = window.open(response.data, '_blank');
									win.focus();}
									else
										alert('Error exporting records')
							})
		}
	
 handleGroupByChange = (event) => {
	let groupFields = this.state.groupBy;
	let index = groupFields.findIndex((x)=> x===event.target.value);
	console.log("inde::::",index);
	if(index<0)
		groupFields.push(event.target.value)
	else
		groupFields.splice(index,1)

	console.log(groupFields);

    this.setState({isLoading:true,groupBy: groupFields});

    let tableColumns = [];
	groupFields.map((f)=>{
		tableColumns.push({
		 dataField: f,
		  text: String(f).charAt(0).toUpperCase() + String(f).slice(1),
		  width: 150,
		  sort: false,
	});
	})
	this.state.reportBy.map((f)=>{
		tableColumns.push({
			dataField: this.state.lookUp[f],
			text: String(f).charAt(0).toUpperCase() + String(f).slice(1),
			width: 150,
			sort: false,
		});
	})
	
	tableColumns.push({
		dataField: 'total',
		  text: 'Current Stocks',
		  sort:false,		 
		   headerStyle: {
    		width: '100px'
  			}
		 
	});
	 
	 getInventoryReport(groupFields.toString(),this.state.reportBy.toString(),this.state.postObj)//.then(response => response.data)
    .then((response) => {
      this.setState({isLoading:false})
      this.setState({ tableData: response.data,columns:tableColumns})
     
     })
  };


   

	 
  render() {
  	//console.log("schedule::::",this.state.schedule);
    return (
      <>

        <div className="row">
			<div className= "col-md-12">
				<Portlet>
					<PortletHeader title="Inventory Report"></PortletHeader>
				</Portlet>
			</div>
		</div>

      	<div className="row">

          	<div className="col-md-12">
            <CodeExample jsCode="true" beforeCodeTitle="Filter" csv ="true" exportClick={this.exportClick.bind(this)} >
						   <div className="kt-section" >
							 <Grid container spacing={3}>
							 
							   
							   <Grid item xs={12} sm={6}>
								 <TextField  style={{'width':'100%'}} name="locationKey" 
									 id="locationKey"  label="Location"
									 onChange={this.handleChangeLocation}
									   select>
										 <MenuItem value="">Select All</MenuItem>
									
									 { 
									 this.state.locations.length>0 && this.state.locations.map((acc) => (
									   
									   <MenuItem key={acc.locationKey} value={acc.locationKey}>{acc.locationName}</MenuItem>
										 
									 ))
									 }
									
										
									
								 </TextField>
		   
							   </Grid>
							   
							 </Grid>
						   </div>
					   
					   <div>
					   <Button
					 variant="outlined"
					 color="primary"
					 onClick={this.handleFilter.bind(this)}
					 endIcon={<Icon>search</Icon>}
					 style={{'padding':'10px','margin':'10px'}}
					 >
					 {
					   this.state.isLoading==true&&<><Bounce /></>
					 }
					 {
					   this.state.isLoading==false&&<>Apply Filter</>
					 }
					 </Button>
					 
					 <Button
					 variant="outlined"
					 color="primary"
					 onClick={this.handleReset.bind(this)}
					 endIcon={<Icon>backspace</Icon>}
					 style={{'padding':'10px','margin':'10px'}}
					 >
					 {
					   this.state.isReset==true&&<><Bounce /></>
					 }
					 {
					   this.state.isReset==false&&<>Reset Filter</>
					 }
					 </Button>
					 </div>
		   
						 </CodeExample>
          	</div>
        </div>
		    
		
		
			<div className="kt-portlet">
				<div className="kt-portlet__body">
					<div className="row">
						<div className="col-md-12">
							<Grid beforeCodeTitle="Accounts" jsCode="true">
								<div className="kt-section">
									{this.state.isLoading===false &&
									<BootstrapTable
										bootstrap4
										keyField="orderKey"
										data={ this.state.tableData }
										columns={ this.state.columns }
										defaultSorted={ this.state.defaultSorted } 
										filter={ filterFactory() }
										pagination={ paginationFactory()}
										paginationSize={100}
										/>
									}
									 {this.state.isLoading && (
															<div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
															  <Alert severity={'info'} icon={this.state.isLoading && <CircularProgress size={15} />}>&nbsp;&nbsp;{'Loading please wait...'}</Alert>      
															</div>
															  )}
								</div>
							</Grid>
						</div>
					</div>
				</div>
			</div>
		
      	
	
		
					
       
		
	
    
      </>
    );
  }
}
